var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-container',[_c('mdb-calendar',{attrs:{"events":_vm.events}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }